import { supabase } from '../../lib/supabase'

export interface GameAccount {
  id: string
  display_name: string
  player_tag: string | null
  region_code: string | null
  is_default: boolean
  collected_count: number
  total_cards: number
  completion_percent: number
  created_at: string
  updated_at: string
}

export async function listGameAccounts(): Promise<GameAccount[]> {
  const { data, error } = await supabase.rpc('game_account_list')
  if (error) throw error
  return ((data ?? []) as Array<Partial<GameAccount>&Pick<GameAccount,'id'|'display_name'|'player_tag'|'region_code'|'is_default'|'created_at'|'updated_at'>>).map((account)=>({
    ...account,
    collected_count:Number(account.collected_count??0),
    total_cards:Number(account.total_cards??0),
    completion_percent:Number(account.completion_percent??0),
  }))
}

export async function createGameAccount(input: {
  displayName: string
  playerTag?: string
  regionCode?: string
}): Promise<string> {
  const { data, error } = await supabase.rpc('game_account_create', {
    p_display_name: input.displayName,
    p_player_tag: input.playerTag || null,
    p_region_code: input.regionCode || null,
  })
  if (error) throw error
  return data as string
}

export async function updateGameAccount(id: string, input: { displayName: string; playerTag?: string; regionCode?: string }) {
  const { error } = await supabase.rpc('game_account_update', {
    p_game_account_id: id, p_display_name: input.displayName,
    p_player_tag: input.playerTag || null, p_region_code: input.regionCode || null,
  })
  if (error) throw error
}

export async function setDefaultGameAccount(id: string) {
  const { error } = await supabase.rpc('game_account_set_default', { p_game_account_id: id })
  if (error) throw error
}

export async function deleteGameAccount(id: string) {
  const { error } = await supabase.rpc('game_account_delete', { p_game_account_id: id })
  if (error) throw error
}
